import React from 'react'
import * as R from 'ramda'
import { useIntl } from 'react-intl'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@material-ui/core'
import CancelButton from 'app/components/buttons/CancelButton'
import DeleteButton from 'app/components/buttons/DeleteButton'
import { isHomelessGroup } from 'commons/groupLogic'
import clsx from 'clsx'
import useMobileStyle from 'app/components/mobileModal/mobileModalStyle'

export default (props) => {
  const { state, classes, toggleDialogs, DELETE_DIALOG, handleDeleteGroups } =
      props,
    { formatMessage } = useIntl()

  const groupCount = R.compose(
    R.length,
    R.filter((v) => !isHomelessGroup(v)),
  )(state.deletedGroupData || [])

  const dialogTitle = formatMessage(
    { id: 'delete.groups.title' },
    { groupCount },
  )
  const description = formatMessage(
    { id: 'group.deleteMsgSelectedItems' },
    { groupCount },
  )

  const mobileClasses = useMobileStyle()

  return (
    <Dialog
      open={state.isOpenDeleteDialog}
      className={clsx(classes.groupDialog, mobileClasses.lessPaddingMobile)}
    >
      <DialogTitle id="alert-dialog-title" className={classes.groupDeleteTitle}>
        {dialogTitle}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {description}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <CancelButton
          onClick={() => {
            toggleDialogs(DELETE_DIALOG, false)
          }}
          className={mobileClasses.modalBtn}
        />
        <DeleteButton
          onClick={handleDeleteGroups}
          className={mobileClasses.modalBtn}
        />
      </DialogActions>
    </Dialog>
  )
}
